(function() {
  'use strict';

  var StickyStatesPlugin = window['@uirouter/sticky-states'].StickyStatesPlugin;
  var Visualizer = (window['@uirouter/visualizer'] || window['ui-router-visualizer']).Visualizer;
  angular.module('providerPortal',['ui.router','registration', 'forgotUser','benefits','userProfile',
    'ngResource','loosebits.client.exception.post', 'dnSecurity', 'general',
    'dnPrinter','pascalprecht.translate', 'common', 'dnErrorDisplay', 'forgotPassword', 'ngCookies',
    'admin', 'dso', 'claims','LocalStorageModule','angular-uuid'])
  .run(['$rootScope', '$http', '$cookies', '$location', 'secSecurityService', 'localStorageService', '$state',
    '$transitions', '$anchorScroll', '$q', '$log', 'taxIdBlockService',
    function($rootScope, $http, $cookies, $location, securityService, localStorageService, $state, $transitions, $anchorScroll, $q, $log, taxIdBlockService) {
    //Adding this because IE does not support array.find
    if (!Array.prototype.find) {
      Object.defineProperty(Array.prototype, 'find', {
        value: function(predicate) {
          if (this == null) {
            throw new TypeError('"this" is null or not defined');
          }
          var o = Object(this);
          var len = o.length >>> 0;
          if (typeof predicate !== 'function') {
            throw new TypeError('predicate must be a function');
          }
          var thisArg = arguments[1];
          var k = 0;
          while (k < len) {
            var kValue = o[k];
            if (predicate.call(thisArg, kValue, k, o)) {
              return kValue;
            }
            k++;
          }
          return undefined;
        }
      });
    }
    
    //IE11 support implement String.prototype.includes
    if (!String.prototype.includes) {
     String.prototype.includes = function(search, start) {
       if (typeof start !== 'number') {
         start = 0;
       }

       if (start + search.length > this.length) {
         return false;
       } else {
         return this.indexOf(search, start) !== -1;
       }
     };
    }
    //IE is the worst browser in history
    if (!Array.prototype.includes) {
      Object.defineProperty(Array.prototype, "includes", {
        enumerable: false,
        value: function(obj) {
            var newArr = this.filter(function(el) {
              return el == obj;
            });
            return newArr.length > 0;
          }
      });
    }
    $rootScope.appVersion = appVersion;
    $rootScope.applicationName = applName;
    $transitions.onStart( {to: 'benefits.dashboard.**'}, function(trans) {
      $rootScope.layout = 'dashboard';
    });
    $transitions.onStart( {from: 'benefits.dashboard.**', to: function(state) {
      return state.name.indexOf('benefits.dashboard') < 0;
    }}, function(trans) {
      $rootScope.layout = 'kit';
    });
    $transitions.onStart( { to: 'root' }, function(trans) {
      securityService.getUserHome().then(function (userHome) {
        if (userHome) {
          trans.router.stateService.transitionTo(userHome);
          return false;
        }
      });
    });
    $transitions.onSuccess({}, () => {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    });

    $anchorScroll.yOffset = 70;
    function populateLoggedInUser() {
      securityService.getLoggedInUser().then(function(data) {
        if (data.authorities) {
          $rootScope.user = data;
          taxIdBlockService.taxIdRules = data.taxBlocks;
        } else {
          $rootScope.user = undefined;
        }
      });
    }
    let createStompConnection = (function() {
      let deferred;
      return function() {
        if (!deferred) {
          deferred = $q.defer();
          let url = $location.protocol() + "://"+ $location.host() + ":"+ $location.port() + "/messages";

          let socket = new SockJS(url,null,{transports: ['websocket']});
          let stompClient = Stomp.over(socket);
          stompClient.connect({}, (frame) => {
            $log.debug(frame);
            deferred.resolve(stompClient);
          });
        }
        return deferred.promise;
      };
    })();

    var sessionTimeoutSubsciptionManager = (function() {
      let subscription;
      return {
        subscribe: function(socketChannelId) {
          if (!socketChannelId) {
            return;
          }
          createStompConnection().then((stompClient) => {
            if (subscription) {
              this.unsubscribe();
            }
            subscription = stompClient.subscribe('/topic/'+socketChannelId, function (message) {
              if(message.body === 'expired' ){
                $cookies.remove('socketChannelId');
                $http.get('protected');
              }
            });
          });
        },
        unsubscribe: function() {
          if (subscription) {
            subscription.unsubscribe();
            subscription = undefined;
          }
        }
      };
    })();

    populateLoggedInUser();

    sessionTimeoutSubsciptionManager.subscribe($cookies.get("socketChannelId"));

    $rootScope.$on('authenticationChanged', function(e, data) {
      if (data.sessionTimedOut) {
        securityService.clearAuthentication();
      }
      populateLoggedInUser();
      if (!data.loggedIn) {
        let allParams = {sessionTimedOut: data.sessionTimedOut, loggedOut: data.loggedOut};
        if (data.state) {
          allParams.lastState = data.state.name;
          allParams = _.merge(allParams, data.state.params);
        }
        $state.go('root',{allParams : allParams});
        $cookies.remove('socketChannelId');
        sessionTimeoutSubsciptionManager.unsubscribe();
      } else {
        sessionTimeoutSubsciptionManager.subscribe(data.socketChannelId);
        if (data.lastState && data.lastState.name) {
          $state.go(data.lastState.name, data.lastState.params);
        } else {
          securityService.getUserHome().then(function (userHome) {
            if (userHome) {
              $state.go(userHome);
            }else{
              $state.go('root', { allParams: {notAuthorized: true}});
            }
          });
        }
      }

    });
    $rootScope.$on('userProfileChanged', function(e, profile) {
      _.merge($rootScope.user, profile);
    });
  }])
  .config(['$compileProvider', function($compileProvider) {
    angular.debug = localStorage.debug === 'true';
    $compileProvider.debugInfoEnabled(angular.debug);
  }])
  .config(['$translateProvider', 'asyncYamlLoaderProvider', function($translateProvider, asyncYamlLoaderProvider) {
	if (applName=='Provider DNA') {
	   asyncYamlLoaderProvider.url('labels-providerdna.yml' + appVersion);
	} else if (applName=='DNoA Connect') {
	   asyncYamlLoaderProvider.url('labels.yml' + appVersion);
	} else {
	   asyncYamlLoaderProvider.url('labels.yml' + appVersion); 
	}
    $translateProvider.useLoader('asyncYamlLoader');
    $translateProvider.preferredLanguage('en');
  }])
  .config(['$logProvider', function(logProvider) {
    logProvider.debugEnabled(angular.debug);
  }])
  .config(['dnErrorMessageServiceProvider', function(errorMessageServiceProvider) {
    errorMessageServiceProvider.errors({
      required: 'This field is required',
      taxId: 'The Tax ID you entered could not be located',
      taxIdFormat: 'Please enter a valid Tax ID (9 digits)',
      min: 'The value entered is too small',
      max: 'The value entered is too large',
      date: 'Please enter a valid date',
      uniqueUserId: 'This User Id is not available',
      email: 'This email address is invalid',
      emailTld: 'This email address is invalid',
      subscriberIdLength: 'Subscriber ID or SSN must be at least 9 characters long',
      validSubscriberId: 'Subscriber ID or SSN can only contain numbers and letters',
      phoneNumberFormat: 'Please enter a valid phone number (10 digits)',
      uniqueEmailAddress: 'This email address is already in use',
      minimumOneLocation: 'At least one location should be added'
    });
  }])
  .config(['$provide','$httpProvider', '$injector',function ($provide, $httpProvider, $injector) {
    $provide.factory('providerHttpErrorHandler', ['$q','$rootScope', '$injector',  function ($q, $rootScope, $injector) {
      return {
        responseError: function (rejection) {
          let method;
          let requestUrl;
          if (rejection && rejection.config) {
            method = rejection.config.headers['X-HTTP-Method-Override'] || rejection.config.method;
            requestUrl = rejection.config.url;
          }
          if (rejection.status == 403) {
              $rootScope.$broadcast('authorizationError', rejection);
          }
          if (rejection.status != 401 && !(rejection.status == 400 && rejection.headers("x-http-password-reset-status") == "Password in history.") ) {
            $rootScope.$broadcast('ajaxError', rejection);
          }
          return $q.reject(rejection);
        }
      };
    }]);
    $provide.factory('httpSessionHandler', ['$cookies', '$rootScope', '$q', '$injector', '$log',
    function($cookies, $rootScope, $q, $injector, $log) {
      const auth_token_key = 'x-auth-token';
      let authToken;
      let broadcastAuthChange = function(sessionTimedOut) {
        return function authChanged() {
          $log.debug('Auth changed');
          let $state = $injector.get('$state');
          let $stateParams = $injector.get('$stateParams');
          $rootScope.$broadcast('authenticationChanged', {loggedIn: false, sessionTimedOut: sessionTimedOut, state: {
            name: $state.current.name,
            params: $stateParams}});
        };
      };
      let sessionTimedOut = _.debounce(broadcastAuthChange(true), 500);
      let notLoggedIn = _.debounce(broadcastAuthChange(false), 500);
      return {
        request: function(config) {
          if (!authToken) {
            authToken = $cookies.get(auth_token_key);
          }
          if (authToken) {
            config.headers[auth_token_key] = authToken;
          }
          return config;
        },
        response: function(httpResponse) {
          let _authToken = httpResponse.headers(auth_token_key);

          if(_authToken !== null && _authToken !== '') {
              authToken = _authToken;
              $cookies.put('x-auth-token', authToken, {path: '/', session: true});
          }
          if(_authToken === "") {
            authToken = undefined;
            if($cookies.get(auth_token_key)) {
              $cookies.remove(auth_token_key);
            }
          }
          return httpResponse;
        },
        responseError: function(rejection) {
          if (rejection.status == 401) {
            authToken = undefined;
            if (rejection.config.url === '/resetPassword') {
              return $q.reject('invalidPasswordResetLink');
            } else if (rejection.config.url === '/verifyEmail') {
              return $q.reject(rejection.headers('x-http-status-message'));
            }
            if($cookies.get(auth_token_key)) {
              $cookies.remove(auth_token_key);
            }
            if (rejection.config && rejection.config.headers['x-auth-token']) {
              sessionTimedOut();
            } else {
              notLoggedIn();
            }
            return $q.reject('session timed out');
          } else if (rejection.status === 403) {
            $injector.get('$state').go('root');
            return $q.reject('autorization error');
          }
          return $q.reject(rejection);
        }
      };
    }]);
    $httpProvider.interceptors.push('httpSessionHandler');
    $httpProvider.interceptors.push('providerHttpErrorHandler');
  }])
  .config(['errorLogServiceProvider', function(errorLogServiceProvider) {
    errorLogServiceProvider.onSuccess('exceptionIdHandler').debounce(1000);
  }])
  .factory('exceptionIdHandler', ['$rootScope', '$log',function($rootScope, $log) {
    return function exceptionIdHandler(exceptionId) {
      $log.warn("Exception id: " + exceptionId);
      $rootScope.$broadcast('exceptionIdReceived', {data: {exceptionId: exceptionId} });
    };
  }])
  .factory('$exceptionHandler',   ['errorLogService', '$window', function(errorLogService, $window) {
    const ignorePatterns = [
      // For ui-grid /w angularjs 1.6 - https://github.com/angular-ui/ui-grid/issues/5890
      /^Possibly unhandled rejection: canceled$/,
      /^Possibly unhandled rejection: not-element$/,
      /^Possibly unhandled rejection: session timed out$/,
      /^Possibly unhandled rejection: autorization error$/
    ];
    return function exceptionHandler (exception, cause) {
      if (ignorePatterns.some(pattern => pattern.test(exception))) {
        return;
      }
      errorLogService(exception, cause);
      if ($window.NREUM) {
        $window.NREUM.noticeError(exception);
      }
    };
  }])
  .run(['$rootScope', '$document', function($rootScope, $document) {
    $rootScope.$on('modal.show', function (e, $modal) {
      $document.find('body').addClass('modal-open');
    });
  }])
  .config(function($uiRouterProvider) {
    $uiRouterProvider.plugin(StickyStatesPlugin);
    if(angular.debug) {
      $uiRouterProvider.plugin(Visualizer);
    }
  })
  ;
})();
